export enum UserRoles {
  SuperAdmin = 0,
  Manager = 1,
  Employee = 2,
}
